import React, { Component } from 'react';
import { Flex, Box } from 'grid-styled';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { ThemeProvider } from 'styled-components';
import Page from './Page';
import connect from '../store/connect';
import { fetchCategoryMetaData, fetchProducts, setViewstate, removeViewstate } from '../actions/actionCreators';
import { Heading } from '../styles/Heading';
import { color, size } from '../styles/helpers/variables';
import { Container } from '../styles/Container';
import { NavigationButton } from '../components/NavigationButton';
import { Preamble } from '../styles/Preamble';
import { FullWidthContainer } from '../styles/FullWidthContainer';
import NotFoundPage from './NotFoundPage';
import ErrorPage from './ErrorPage';
import ProductListWithFilters from '../components/ProductListWithFilters';
import { getProductsByKey } from '../selectors/reselectCategory';

class ParentCategoryPage extends Component {
  componentDidMount() {
    this.getPageData(this.props.match.url, this.props.item.get('id'));

    if (this.props.viewstate.get('currentCategory') !== this.props.item.get('id')) {
      this.setDefaultFilters(this.props.item.get('id'));
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.viewstate.get('currentCategory') !== nextProps.item.get('id') &&
      this.props.item.get('id') !== nextProps.item.get('id')
    ) {
      this.getPageData(nextProps.match.url, nextProps.item.get('id'));
      this.setDefaultFilters(nextProps.item.get('id'));
    }
  }

  getPageData(pageUrl, categoryId) {
    this.props.fetchCategoryMetaData({
      url: pageUrl
    });

    this.props.fetchProducts({
      id: categoryId,
      url: pageUrl
    });
  }

  setDefaultFilters(categoryId) {
    this.props.setViewstate('currentCategory', categoryId);
    this.props.setViewstate('sortAscending', false);
    this.props.setViewstate('sortBy', 'name');
    this.props.removeViewstate('filter');
    this.props.setViewstate('pagination', 0);
  }

  render() {
    const { currentCategory, item, request } = this.props;

    if (request.get('statusCode') === 404 || item.isEmpty()) return <NotFoundPage />;
    if (request.get('status') === 'ERROR') return <ErrorPage />;

    const childRoutes = this.props.item.get('children');
    const subcategoryButtons = childRoutes
      .map(childRoute => (
        <Box
          key={childRoute.get('id')}
          width={[1, 1, 1 / 2, 1 / 2, 1 / 3]}
          py={['5px', '8px', '11px']}
          px={['0px', '8px', '11px']}
        >
          <NavigationButton
            url={childRoute.get('url')}
            image={childRoute.get('image')}
            title={childRoute.get('title')}
          />
        </Box>
      ))
      .toArray();

    return (
      <Page meta={currentCategory.get('metaData')} bgColor={color.lightGrey}>
        <FullWidthContainer bgColor={color.lightGrey}>
          <Container>
            <Heading big center>
              {currentCategory.get('name')}
            </Heading>
            <Preamble>{currentCategory.get('description')}</Preamble>
            <ThemeProvider
              theme={{
                breakpoints: ['500px', '800px', `${size.large}px`, '1100px']
              }}
            >
              <Flex flexWrap="wrap" mx={['0px', '-8px', '-11px']} mt={60} mb={20}>
                {subcategoryButtons}
              </Flex>
            </ThemeProvider>
          </Container>

          <ProductListWithFilters
            includeCategoryFilter
            request={this.props.productRequest}
            allProducts={this.props.products}
          />
        </FullWidthContainer>
      </Page>
    );
  }
}

ParentCategoryPage.defaultProps = {
  item: Map(),
  currentCategory: Map(),
  request: Map(),
  productRequest: Map(),
  products: Map(),
  viewstate: Map()
};

ParentCategoryPage.propTypes = {
  match: PropTypes.object.isRequired,
  item: PropTypes.instanceOf(Map),
  currentCategory: PropTypes.instanceOf(Map),
  request: PropTypes.instanceOf(Map),
  productRequest: PropTypes.instanceOf(Map),
  products: PropTypes.instanceOf(Map),
  viewstate: PropTypes.instanceOf(Map),
  fetchCategoryMetaData: PropTypes.func.isRequired,
  fetchProducts: PropTypes.func.isRequired,
  setViewstate: PropTypes.func.isRequired,
  removeViewstate: PropTypes.func.isRequired
};

export default connect(
  ParentCategoryPage,
  { fetchCategoryMetaData, fetchProducts, setViewstate, removeViewstate },
  (store, props) => {
    const currentCategory = store.categories.items.get(props.location.pathname.replace(/\/$/, '')) || Map();

    return {
      viewstate: store.viewstate,
      currentCategory,
      request: store.categories.request.get(props.location.pathname.replace(/\/$/, '')),
      productRequest: store.products.request.get(props.location.pathname.replace(/\/$/, '')),
      products: getProductsByKey(store, ['category', 'url'], currentCategory.get('url'))
    };
  }
);



// WEBPACK FOOTER //
// ./src/pages/ParentCategoryPage.js